import { CompanyResponse } from "./dto/fidelityCustomer.dto";
import {
  FidelityCustomerField,
  initializeUser,
  UserDto,
} from "./dto/user.dto";
import { FidelityCustomer } from "./models/fidelityCustomer.model";

let user: UserDto = initializeUser();
let totalSteps: number = 3;
let formUser: FidelityCustomer;
const companyId = "0195234f-477e-7fb6-bfab-c8aec45b4665";
let company: CompanyResponse;

// Inactivity Timeout
type InactivityTimeout = ReturnType<typeof setTimeout> | undefined;
let inactivityTimeout: InactivityTimeout = undefined;
export const TIMEOUT_DURATION: number = 120000; // 120 seconds in milliseconds

export function getInactivityTimeout(): InactivityTimeout {
  return inactivityTimeout;
}
export function setInactivityTimeout(timeout: InactivityTimeout): void {
  inactivityTimeout = timeout;
}

// Notification Countdown Interval
type CountdownInterval = ReturnType<typeof setInterval> | null;
let notificationCountdownInterval: CountdownInterval = null;

export function getNotificationCountdownInterval(): CountdownInterval {
  return notificationCountdownInterval;
}
export function setNotificationCountdownInterval(val: CountdownInterval): void {
  notificationCountdownInterval = val;
}

// Company
export function getCompanyId(): string {
  return companyId;
}

export function getCompany(): CompanyResponse {
  return company;
}
export function setCompany(newCompany: CompanyResponse): void {
  company = newCompany;
}

// User
export function getUser(): UserDto {
  return user;
}
export function setUser(newUser: UserDto): void {
  user = newUser;
}
export function setUserProperty<T extends keyof UserDto>(
  key: T,
  value: UserDto[T] extends Array<infer V> ? V : UserDto[T]
): void {
  if (key === "additionalData") {
    user.additionalData.push(value as FidelityCustomerField);
  } else {
    user[key] = value;
  }
}

export function resetUserAdditionalData(): void {
  user.additionalData = [];
}

// Form User
export function setFormUser(newFormUser: FidelityCustomer): void {
  formUser = newFormUser;
}

export function getFormUser(): FidelityCustomer {
  return formUser;
}

// Total Steps
export function getTotalSteps(): number {
  return totalSteps;
}

export function setTotalSteps(totalStepsInput: number): void {
  totalSteps = totalStepsInput;
}
